var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menuSuperior" }, [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-8" }, [
        _c("div", { staticClass: "esquerdaMenuSuperior" }, [
          _c("ul", { staticClass: "listaMenuSuperior" }, [
            _c("li", [
              _c("span", { staticClass: "user" }, [_vm._v("Olá, ")]),
              _vm._v(
                _vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name)
              )
            ]),
            _vm._v(" "),
            _c(
              "li",
              {
                attrs: { title: "Sair" },
                on: {
                  click: function($event) {
                    return _vm.logout()
                  }
                }
              },
              [_vm._m(1)]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-4" }, [
      _c("figure", [
        _c("a", { attrs: { href: "#" } }, [
          _c("img", {
            attrs: {
              src: "/static/resources/images/logo_white.png",
              alt: "Logo Audiotext"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "menu sair", attrs: { href: "#" } }, [
      _c("i", { staticClass: "fas fa-sign-out-alt" }),
      _vm._v(" "),
      _c("span", [_vm._v(" Sair")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-470c775a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-470c775a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav/Headerbar.vue
// module id = null
// module chunks = 